import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';


@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    standalone: false
})

export class ContactUsComponent implements OnInit {
  submitted = false;
  contactForm: FormGroup = new FormGroup({});
  SetFormControl() {
    this.contactForm = new FormGroup({
      fcCompanyName: new FormControl('', Validators.required),
      fcFirstName: new FormControl('', Validators.required),
      fcLastName: new FormControl('', Validators.required),
      fcEmail: new FormControl('', Validators.required),
    });
  }
  get cf() {
    return this.contactForm.controls;
  }

  resolved(captchaResponse: string) {
    // console.log(`Resolved captcha with response: ${captchaResponse}`);
  }
  submit(){
    this.submitted = true;
      // console.log(this.contactForm);
    if (this.contactForm.invalid) {
      window.scrollTo(0, 0);
      return;
    }
  }
  constructor() { }

  ngOnInit(): void {
    this.SetFormControl();
    console.clear();
  }

}
